import { QueryClient } from '@tanstack/react-query';

// Create a client with defaults that match our existing data fetching functionality
const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: 0,
            refetchOnReconnect: false,
            refetchOnWindowFocus: false,
            staleTime: 60 * 1000
        }
    }
});

export default queryClient;
